// Em src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// Ícones um pouco maiores e mais consistentes
import { FaSignOutAlt, FaUserCircle, FaChevronDown, FaBars } from 'react-icons/fa'; 
import { API_BASE_URL } from '../config';
import styles from './Header.module.css';
import logo from '../img/logo.png';

const Header = ({ isAuthenticated, setAuthenticated }) => {
  const navigate = useNavigate();
  const [userPhoto, setUserPhoto] = useState(null);
  // NOVO: Estado para guardar o nome do usuário
  const [userName, setUserName] = useState('Seu Acesso'); 
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

   useEffect(() => {
    if (isAuthenticated) {
      const photoUrl = localStorage.getItem('foto_perfil_url');
      // NOVO: Pega o nome do usuário do localStorage (assumindo que você o salve lá)
      const storedName = localStorage.getItem('user_name'); 

      if (photoUrl && photoUrl !== 'null') {
        setUserPhoto(`${API_BASE_URL}${photoUrl}`);
      } else {
        setUserPhoto(null);
      }
      
      if (storedName) {
        setUserName(storedName);
      }

    } else {
      setUserPhoto(null);
      setUserName('Seu Acesso');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tipo_usuario');
    localStorage.removeItem('authenticated');
    localStorage.removeItem('foto_perfil_url');
    // NOVO: Limpa o nome do usuário também
    localStorage.removeItem('user_name');
    setAuthenticated(false);
    setDropdownOpen(false);
    navigate('/login');
  };

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  return (
    <>
      <header className={styles.appHeader}>
        <div className={styles.headerContent}>
          <div className={styles.leftSection}>
        
            <Link to="/" className={styles.headerLogoLink}>
              <img src={logo} alt="Logo" className={styles.headerLogo} />
            </Link>
          </div>

          {isAuthenticated && (
            <nav className={styles.userNav}>
              <div className={styles.userMenu} ref={dropdownRef}>
                <button onClick={toggleDropdown} className={styles.userMenuButton}>
                  {userPhoto ? (
                    <img src={userPhoto} alt="Foto do perfil" className={styles.profileAvatar} />
                  ) : (
                    // Ícone maior e mais limpo
                    <div className={styles.profilePlaceholder}>
                        <FaUserCircle />
                    </div>
                  )}
                  <FaChevronDown className={`${styles.chevronIcon} ${isDropdownOpen ? styles.open : ''}`} />
                </button>

                {isDropdownOpen && (
                  <div className={styles.dropdownMenu}>
                     <div className={styles.dropdownHeader}>
                        {/* MUDANÇA: Usando o estado do nome do usuário */}
                        <span className={styles.userName}>{userName}</span>
                      </div>
                      <Link to="/perfil" className={styles.dropdownLink} onClick={() => setDropdownOpen(false)}>
                        <FaUserCircle className={styles.dropdownIcon} /> Meu Perfil
                      </Link>
                      <button onClick={handleLogout} className={`${styles.dropdownLink} ${styles.logoutButton}`}>
                        <FaSignOutAlt className={styles.dropdownIcon} /> Sair
                      </button>
                  </div>
                )}
              </div>
            </nav>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;